import dayjs from 'dayjs';

import type { OccupancyInterface } from '@valk-nx/helpers/lib/interfaces/occupancy.interface';

/**
 * Base URL of the VHI (Van der Valk Exclusief) booking engine. VHI hotels
 * redirect straight to this handler instead of going through the regular
 * booking-tool redirect API.
 */
const VHI_BOOKING_BASE_URL =
	'https://www.valkexclusief.nl/handlers/BookingsEngine.ashx';

export interface VhiBookingParams {
	code: string;
	language: string;
	startDate: string;
	endDate: string;
	occupancy: OccupancyInterface[];
}

export function generateVhiBookingUrl({
	code,
	language,
	startDate,
	endDate,
	occupancy,
}: VhiBookingParams): string {
	const nights = dayjs(endDate).diff(dayjs(startDate), 'day');

	const totals = occupancy.reduce(
		(acc, room) => ({
			adults: acc.adults + room.adults,
			children: acc.children + room.children,
			infants: acc.infants + room.infants,
		}),
		{ adults: 0, children: 0, infants: 0 },
	);

	const url = new URL(VHI_BOOKING_BASE_URL);
	url.searchParams.set('language', language);
	url.searchParams.set('IDPMS', code);
	url.searchParams.set('date', startDate);
	url.searchParams.set('adults', String(totals.adults));
	url.searchParams.set('children', String(totals.children));
	url.searchParams.set('infants', String(totals.infants));
	url.searchParams.set('nights', String(nights));

	return url.toString();
}
